import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
	putToken: ['token'],
	loginRequest: ['credentials'],
	loginSuccess: ['profile'],
	logoutRequest: null,
	logoutSuccess: null,
	registerRequest: ['data'],
	createTeamRequest: ['data'],
	createTeamSuccess: ['profile'],
	switchTeamSuccess: ['profile'],
	resendVerificationRequest: ['email'],
})

export const authTypes = Types
export default Creators
